<template>
    <vs-popup class="add-new-incoterms" id="popup" title="CUSTOMER LEAD SITE MANAGE" @close="open = false" :active.sync="open"
        :buttons-hidden="true">
        <vx-card no-shadow>
            <vs-button class="float-right mb-2" @click.stop="onClickCreateSite">create new site</vs-button>
            <vs-table :data="data_list">

                <template slot="thead">
                    <vs-th>NAME</vs-th>
                    <vs-th>LINE 1</vs-th>
                    <vs-th>LINE 2</vs-th>
                    <vs-th>LINE 3</vs-th>
                    <vs-th>TOWN/STATE</vs-th>
                    <vs-th>POSTAL CODE</vs-th>
                    <vs-th>COUNTRY</vs-th>
                    <vs-th width="10%">ADDITIONAL INFO</vs-th>
                    <vs-th width="10%">NOTE</vs-th>
                    <vs-th>ACTION</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr @click.native="onClickUpdateSite(data[indextr].id)" :key="indextr" v-for="(tr, indextr) in data" class="cursor-pointer">

                        <vs-td :data="data[indextr].name">
                            {{ data[indextr].name }}
                        </vs-td>

                        <vs-td :data="data[indextr].address.line1">
                            {{ data[indextr].address.line1 }}
                        </vs-td>

                        <vs-td :data="data[indextr].address.line2">
                            {{ data[indextr].address.line2 }}
                        </vs-td>

                        <vs-td :data="data[indextr].address.line3">
                            {{ data[indextr].address.line3 }}
                        </vs-td>

                        <vs-td :data="data[indextr].address.town_state">
                            {{ data[indextr].address.town_state }}
                        </vs-td>

                        <vs-td :data="data[indextr].address.post_code">
                            {{ data[indextr].address.post_code }}
                        </vs-td>

                        <vs-td :data="data[indextr].address.country">
                            {{ data[indextr].address.country }}
                        </vs-td>

                        <vs-td :data="data[indextr].additional_info">
                            {{ data[indextr].additional_info || 'N/A' }}
                        </vs-td>

                        <vs-td>
                            {{ data[indextr].notes || 'N/A' }}
                        </vs-td>
                        <vs-td>
                            <div class="vx-row">
                                <vx-tooltip class="mr-2" text="VIEW/UPDATE SITE" position="top">
                                    <vs-button @click.stop="onClickUpdateSite(data[indextr].id)" size="small"
                                        color="primary" type="border" icon-pack="feather"
                                        icon="icon-eye"></vs-button>
                                </vx-tooltip>
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>

            </vs-table>
        </vx-card>
        <CreateCustomerLeadSitePopUp ref="createCustomerLeadSitePopUp" v-on:refreshData="fetchLeadSiteList"/>
    </vs-popup>
</template>
  
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const CrmRepository = RepositoryFactory.get('crm');

import vSelect from 'vue-select'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import CreateCustomerLeadSitePopUp from './CreateCustomerLeadSitePopUp.vue';

function initialState() {
    return {
        open: false,
        id: '',
        data_list: [],
    }
}

export default {
    name: 'MarketingLeadsAddressPopUp',
    data() {
        return initialState()
    },
    methods: {
        async openPopup(id) {
            try {
                await Object.assign(this.$data, initialState());
                this.open = true;
                this.id = id
                await this.fetchLeadSiteList()
            } catch (error) {

            }
        },
        async fetchLeadSiteList() {
            try {
                const { data } = await CrmRepository.getLeadSiteList(this.id)
                this.data_list = data.data
            } catch (error) {
                this.convertAndNotifyError(error);
            }
        },
        onClickCreateSite() {
            this.$refs.createCustomerLeadSitePopUp.openPopup(this.id)
        },
        onClickUpdateSite(site_id) {
            this.$refs.createCustomerLeadSitePopUp.openPopup(this.id, site_id)
        }
    },
    components: {
        'v-select': vSelect,
        CreateCustomerLeadSitePopUp,
    },
    mixins: [SuccessMessage, ErrorMessages],
}
</script>
  
<style scoped>
.add-new-incoterms>>>.vs-popup {
    /* min-height: 30% !important; */
    min-width: 60% !important;
}
</style>
  